import { kpiApi } from "@/api/kpiApi";
import { tagApi } from "@/api/tagApi";
// import { userApi } from "@/api/userApi";
import { Search } from "@mui/icons-material";
import { Box, Button, Card, Container, Divider, Grid, MenuItem, Stack, Typography } from "@mui/material";
import { Field, Form, FormikProvider, useFormik } from "formik";
import { TextField } from "formik-mui";
import { Suspense, useState } from "react";
import * as yup from "yup";
import DashboardHeader from "../DashboardHeader";
import KpiBasicChart from "@/components/KpiBasicChart";
import KpiBasicChartCard from "@/components/KpiBasicChartCard/KpiBasicChartCard";

const filterInitialValues = {
    tagId: "",
    groupId: "",
};

const filterValidationSchema = yup.object().shape(
    {
        tagId: yup.number().when("groupId", {
            is: (value) => !value || value.length === 0,
            then: (schema) => schema.required(),
        }),
        groupId: yup.number().when("tagId", {
            is: (value) => !value || value.length === 0,
            then: (schema) => schema.required(),
        }),
    },
    [["tagId", "groupId"]]
);

function KpiFilterForm(props) {
    const { updateData } = props;
    const getTags = tagApi.endpoints.getTags.useQuery({
        namespace: ["KPI/ResultsAnalysis/ResultItem"],
    });
    const getGroups = kpiApi.endpoints.getKpiResponsibleGroup.useQuery({
        is_active: true,
        page: { size: 1000 },
    });
    const tagOptions = getTags.data?.data ?? [];
    const groupOptions = getGroups.data?.data ?? [];
    const [refreshGetKpis, getKpis] = kpiApi.endpoints.searchKpi.useLazyQuery();
    const handleSubmit = async ({ tagId, groupId }) => {
        try {
            const kpis = await refreshGetKpis({
                filter: {
                    kpi_type_id: 5,
                    tag_id: tagId,
                    group_id: groupId,
                },
                page: {
                    size: 1000,
                },
            }).unwrap();
            updateData(kpis.data ?? []);
        } catch (error) {
            console.error(error);
            updateKpiList([]);
        }
    };
    const formik = useFormik({
        initialValues: filterInitialValues,
        validationSchema: filterValidationSchema,
        onSubmit: handleSubmit,
    });

    return (
        <Card sx={{ padding: 1, paddingX: 2 }}>
            <FormikProvider value={formik}>
                <Form>
                    <Stack direction="row" spacing={1} sx={{ alignItems: "top", justifyContent: "flex-start" }}>
                        <Typography>ค้นหา</Typography>
                        <Divider variant="middle" orientation="vertical" flexItem />
                        <Field
                            component={TextField}
                            select={true}
                            size="small"
                            name="tagId"
                            sx={{ width: 300 }}
                            SelectProps={{
                                displayEmpty: true,
                            }}
                        >
                            <MenuItem key="all" value="">
                                Result Item ทั้งหมด
                            </MenuItem>
                            <Divider />
                            {tagOptions.map((tag) => (
                                <MenuItem key={tag.id} value={tag.id}>
                                    {tag.title}
                                </MenuItem>
                            ))}
                        </Field>
                        <Field
                            component={TextField}
                            select={true}
                            size="small"
                            name="groupId"
                            sx={{ width: 300 }}
                            SelectProps={{
                                displayEmpty: true,
                            }}
                        >
                            <MenuItem key="all" value="">
                                หน่วยงาน ทั้งหมด
                            </MenuItem>
                            <Divider />
                            {groupOptions.map((group) => (
                                <MenuItem key={group.id} value={group.id}>
                                    {group.title}
                                </MenuItem>
                            ))}
                        </Field>
                        <Box>
                            <Button
                                type="submit"
                                variant="contained"
                                startIcon={<Search />}
                                disableElevation
                                disabled={formik.isSubmitting}
                            >
                                ค้นหา
                            </Button>
                            <Button type="reset" disableElevation>
                                reset
                            </Button>
                        </Box>
                    </Stack>
                </Form>
            </FormikProvider>
        </Card>
    );
}

export default function KpiGraphDashboard(props) {
    const [data, setData] = useState([]);
    const handleUpdateData = (value) => setData(value ?? []);

    return (
        <>
            <Container>
                <DashboardHeader title={"ผลการดำเนินงานองค์กร"} />
                <KpiFilterForm updateData={handleUpdateData} />
                <Box>total: {data.length ?? "-"}</Box>
            </Container>
            <Container sx={{ marginTop: 5 }}>
                <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={1}>
                    {data?.map((kpi) => (
                        <Grid key={kpi.id} item xs={12} md={6} xl={4}>
                            <KpiBasicChartCard kpiId={kpi.id} />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </>
    );
}
